// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// DaisyUI-styled confirm dialog that works across Turbo visits.
// Look up the dialog inside the handler each time so we always use the dialog
// currently in the DOM (after Turbo Drive replaces the body, a cached reference
// would be detached and dialog.isConnected would be false, triggering native confirm).
const setupTurboConfirm = () => {
  Turbo.config.forms.confirm = (message, element, submitter) => {
    const dialog = document.getElementById("turbo-confirm-dialog")
    if (!dialog) return Promise.resolve(confirm(message))

    const title = document.getElementById("turbo-confirm-title")
    const messageEl = document.getElementById("turbo-confirm-message")
    const confirmButton = dialog.querySelector("button[value='confirm']")

    messageEl.textContent = message
    title.textContent = submitter?.dataset.turboConfirmTitle || "Confirm"
    confirmButton.textContent = submitter?.dataset.turboConfirmButton || "Confirm"

    dialog.showModal()

    return new Promise((resolve) => {
      dialog.addEventListener(
        "close",
        () => resolve(dialog.returnValue === "confirm"),
        { once: true }
      )
    })
  }
}

document.addEventListener("turbo:load", setupTurboConfirm)
document.addEventListener("turbo:before-cache", () => {
  const dialog = document.getElementById("turbo-confirm-dialog")
  if (dialog?.open) dialog.close()
})
